/**
 * Arayüz yoğunluğu (görünüm ölçeği).
 *
 * Tüm uzunluklar rem tabanlıdır; ölçek kök font-size ile verilir
 * (kurallar index.css'te). Bu modül yalnızca seçimi saklar ve
 * <html data-density="..."> özniteliğini günceller.
 *
 * Seviyeler:
 *   compact → %75  (çok ekrana çok satır)
 *   normal  → %85  (varsayılan — "%100'de devasa görünüyor" şikayetinin çözümü)
 *   large   → %100 (eski görünüm; erişilebilirlik için korunur)
 */
export type Density = "compact" | "normal" | "large";

export const DENSITY_LEVELS: { value: Density; label: string; hint: string }[] = [
  { value: "compact", label: "Kompakt", hint: "Daha çok satır, küçük yazı (%75)" },
  { value: "normal", label: "Normal", hint: "Önerilen görünüm (%85)" },
  { value: "large", label: "Büyük", hint: "Eski görünüm (%100)" },
];

const STORAGE_KEY = "ui-density";
const DEFAULT_DENSITY: Density = "normal";

const isDensity = (v: unknown): v is Density =>
  v === "compact" || v === "normal" || v === "large";

export function getDensity(): Density {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isDensity(saved)) return saved;
  } catch {
    /* gizli pencere vb. — varsayılana düş */
  }
  return DEFAULT_DENSITY;
}

/**
 * Seçimi kalıcılaştırır ve kök özniteliği günceller. Ölçek rem tabanlı
 * (kök font-size) olduğundan değişiklik anında, sayfa yenilenmeden uygulanır.
 */
export function setDensity(density: Density): void {
  try {
    localStorage.setItem(STORAGE_KEY, density);
  } catch {
    /* saklanamazsa da bu oturumda uygula */
  }
  document.documentElement.dataset.density = density;
}

/** Uygulama açılışında, React render edilmeden önce çağrılır (index.tsx). */
export function initDensity(): void {
  document.documentElement.dataset.density = getDensity();
}
